import { Table as TableBase } from "../Table.component";
import { TableHeader } from "../TableHeader.component";
import { TableBody } from "../TableBody.component";
import { TableRow } from "../TableRow.component";
import { TableRowHeader } from "../TableRowHeader.component";
import { TableCell } from "../TableCell.component";
import { TableEmptyCell } from "../TableEmptyCell.component";
import { TableHeaderCell } from "../TableHeaderCell.component";
import { TableEmptyHeaderCell } from "../TableEmptyHeaderCell.component";

/* eslint-disable @typescript-eslint/naming-convention */
export const Table = Object.assign(TableBase, {
    Header: TableHeader,
    Body: TableBody,
    Row: TableRow,
    RowHeader: TableRowHeader,
    Cell: TableCell,
    EmptyCell: TableEmptyCell,
    HeaderCell: TableHeaderCell,
    EmptyHeaderCell: TableEmptyHeaderCell
});
